import React, { useState } from 'react';
import { HStack, Spacer, Text, VStack } from 'native-base';

// Assets & Icons
import { UserIcon as UsersIcon } from 'react-native-heroicons/solid';
import { LoginIcon as JoinIcon } from 'react-native-heroicons/outline';
import { theme } from '@breakroom-nx/assets';

// Components
import { ChatBubble, SecondaryButton, TertiaryButton } from '../../';

// Classes & Types
import { Room } from '@breakroom-nx/classes';

// Redux
import { useAppDispatch } from '@breakroom-nx/redux';

// Props
type Props = {
  room: Room;
  onPress?: any;
};

export const ChatListActionCell = ({ room, onPress = null }: Props) => {
  // Redux
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  return (
    <HStack px={5} mt={4}>
      <HStack space={4} alignItems={'center'}>
        <ChatBubble room={room} key={room.id} disabled={true} />
        <VStack justifyContent={'flex-start'}>
          <Text variant={'chatTitle'}>{room.title}</Text>
          <HStack
            space={'2px'}
            alignItems={'center'}
            justifyContent={'flex-start'}
          >
            <UsersIcon size={10} color={theme.colors.surface[600]} />
            <Text fontSize={13} fontWeight={600} color={'surface.600'}>
              {room.members?.length.toLocaleString()}
            </Text>
          </HStack>
        </VStack>
      </HStack>

      <Spacer />
      <HStack alignItems={'center'} space={2}>
        <SecondaryButton
          onPress={() => setLoading(true)}
          mini
          text="Join"
          startIcon={<JoinIcon size={16} />}
          disabled={loading}
          fontSize={14}
          color={theme.colors.primary[400]}
        />
        <TertiaryButton
          onPress={() => setLoading(true)}
          mini
          text="Ignore"
          fontSize={14}
          color={theme.colors.surface[500]}
          disabled={loading}
        />
      </HStack>
    </HStack>
  );
};
